import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import FavoriteBooksTab from './components/FavoriteBooksTab';

const FavoritesPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      
      {/* Spațiu pentru header-ul fix */}
      <div className="pt-24 md:pt-28"></div>
      
      <main className="flex-grow pb-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white shadow rounded-lg p-6 mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Cărțile mele favorite</h1>
                <p className="mt-1 text-sm text-gray-500">
                  Toate cărțile pe care le-ai adăugat la favorite
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="p-6">
              <FavoriteBooksTab />
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default FavoritesPage; 